import { FC } from 'react';
import { Box, Flex, Spacer } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ListPageTitle } from 'components/atoms/ListPageTitle';
import { APP_ROUTES } from 'constants/appRoutes';
import { RegistrationButton } from '../../../../../components/atoms/RegistrationButton';

type Props = {
  handleClickRegistration: () => void;
};

export const ComponentHeaderView: FC<Props> = ({ handleClickRegistration }) => (
  <Box m="40px 5px 0 5px">
    <Flex justifyContent="space-between" alignItems="center" h="40px">
      <Box pb={1} borderBottom="5px solid #3182ce">
        <Link to={APP_ROUTES.RELEASECOMPONENT}>
          <ListPageTitle title="コンポーネント一覧" color="#3182ce" />
        </Link>
      </Box>
      <Box pl={5} pb={1}>
        <Link to={APP_ROUTES.RELEASEENVIRONMENT}>
          <ListPageTitle title="環境一覧" />
        </Link>
      </Box>
      <Box pl={5} pb={1}>
        <Link to={APP_ROUTES.RELEASETASK}>
          <ListPageTitle title="リリースタスク一覧" />
        </Link>
      </Box>
      <Spacer />
      <RegistrationButton
        label="コンポーネント新規作成"
        width="auto"
        onClick={handleClickRegistration}
      />
    </Flex>
  </Box>
);
